import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import { SubContractorServices } from './contractor.service';
import {ModuleList} from '../models/contractor';


@Injectable()
export class ContractorListByBusinessResolver {
    constructor(private backend: SubContractorServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getContractorByBusiness(BaseServices.BusinessId);
    }
}

@Injectable()
export class ContractorEditByResolver {
    constructor(private backend: SubContractorServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.get(+route.params['cid']);
    }
}

@Injectable()
export class ModuleListResolver {
    constructor(private backend: SubContractorServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ModuleList[]> {
        return this.backend.getProjectByUser(BaseServices.UserId,BaseServices.BusinessId);
    }
}
